import { Box } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import EpcIndicator from './EpcIndicator';
const EpcChartIndcators = ({ bands, barHeight, current, potential, isLoading, }) => {
    const tokens = useTokens();
    const getIndicatorProperties = (value) => {
        if (!value)
            return null;
        const bandIndex = bands.findIndex(({ range }) => value >= range[0] && value <= range[1]);
        if (bandIndex === -1)
            return null;
        const textColor = bands[bandIndex].variant === 'white'
            ? tokens.TextWhite100
            : tokens.TextBlack800;
        return {
            top: `calc(${bandIndex} * (${barHeight} + ${tokens.Spacing01}))`,
            color: bands[bandIndex].color,
            textColor,
            value,
        };
    };
    const currentIndicator = getIndicatorProperties(current);
    const potentialIndicator = getIndicatorProperties(potential);
    return (React.createElement(Box, { "data-testid": "epc_chart_indicators", position: "absolute", right: "0", top: "0" },
        currentIndicator && (React.createElement(EpcIndicator, { "data-testid": "epc_indicator__current", key: "current", right: "50px", isLoading: isLoading, value: currentIndicator.value, color: currentIndicator.color, textColor: currentIndicator.textColor, top: currentIndicator.top })),
        potentialIndicator && (React.createElement(EpcIndicator, { "data-testid": "epc_indicator__potential", key: "potential", isLoading: isLoading, right: "0px", value: potentialIndicator.value, color: potentialIndicator.color, textColor: potentialIndicator.textColor, top: potentialIndicator.top }))));
};
export default EpcChartIndcators;
